import config from 'constants/config'

/**
 * Returns true when `current tier` is at or above `campaign tier` in the loyalty hierarchy.
 * Returns false if either tier is undefined.
 */
export function isAtOrAboveLoyaltyTier(currentTier?: App.LoyaltyTier, campaignTier?: App.LoyaltyTier) {
  if (!currentTier || !campaignTier) return false

  return config.loyalty.tiersOrder.indexOf(currentTier) >= config.loyalty.tiersOrder.indexOf(campaignTier)
}
